// extracted by mini-css-extract-plugin
export default {"boxy":"Login_boxy__UTW7A"};